// setting users cursors
import * as AceCollabExt from '@convergencelabs/ace-collab-ext';

// message.userId,
//                   message.user,
//                   message.color,
//                   message.userRow,
//                   radarView,
//                   localUser,
//                   aceEditor,
//                   radarFeat

export const setRadarViews = (
  userId,
  user,
  color,
  row,
  radarView,
  localUser,
  aceEditor,

  from
) => {
  // console.log('setting radar views from', from);
  // console.log(row);

  if (aceEditor.current) {
    if (radarView) {
      try {
        radarView.setCursorRow(userId, row + 1);

        setTimeout(function () {
          // @ts-ignore
          const viewportIndices =
            AceCollabExt.AceViewportUtil.getVisibleIndexRange(
              // @ts-ignore
              aceEditor.current.editor
            );
          // @ts-ignore
          const rows = AceCollabExt.AceViewportUtil.indicesToRows(
            // @ts-ignore
            aceEditor.current.editor,
            viewportIndices.start,
            viewportIndices.end
          );

          radarView.setViewRows(userId, rows);
        }, 0);
      } catch (error) {
        try {
          const initialIndices =
            AceCollabExt.AceViewportUtil.getVisibleIndexRange(
              aceEditor.current.editor
            );
          const initialRows = AceCollabExt.AceViewportUtil.indicesToRows(
            aceEditor.current.editor,
            initialIndices.start,
            initialIndices.end
          );

          radarView.addView(userId, user.name, color, initialRows, 0);
          radarView.setViewRows(userId, row + 1);
        } catch (error) {
          console.log('ultimate radar error');
        }
      }
    }
  }
};

export const setCursors = (
  userId,
  user,
  color,
  row,
  column,
  allUsers,
  curMgr,
  updateUserCurStore,
  localUser,
  cursorFeat
) => {
  console.log(cursorFeat);
  if (localUser.userId === userId) {
    // console.log('local user');
    return;
  }

  if (!cursorFeat) {
    try {
      curMgr.removeAll();
    } catch (error) {
      console.log('err');
    }
    return;
  }

  if (cursorFeat) {
    try {
      curMgr.setCursor(userId, { row, column });
    } catch (error) {
      //  console.log('error setting cursor');
      //  console.log('setting new cursor');

      curMgr.addCursor(userId, user, color, {
        row: row,
        column: column,
      });
      curMgr.setCursor(userId, { column, row });
    }
  }
  // console.log(curMgr);
  return;
};

//responsible for passing change in contents of editor; onChange
export const validateInput = (
  value,
  aceEditor,
  socket,
  curMgr,
  localUser,
  cursorFeat
) => {
  // console.log(value); //logs the value of the editor
  const { row, column } = aceEditor.current.editor.getCursorPosition();

  socket.emit('sendCode', { value, row, column });

  if (!cursorFeat) {
    try {
      curMgr.removeAll();
    } catch (error) {
      console.log('err');
    }
    return;
  }

  aceEditor.current.editor.selection.on('changeCursor', function (e) {
    const cursor = aceEditor.current.editor.getCursorPosition();
    try {
      if (cursorFeat) {
        curMgr.setCursor(localUser.userId, cursor);
      } else {
        try {
          curMgr.removeAll();
        } catch (error) {}
      }
    } catch (error) {
      if (cursorFeat) {
        curMgr.addCursor(
          localUser.userId,
          localUser.name,
          localUser.color,
          cursor
        );
        curMgr.setCursor(localUser.userId, cursor);
      } else {
        try {
          curMgr.removeAll();
        } catch (error) {}
      }
    }
  });
};

// responsible for passing change in cursor position; onChangeSelection
export const updateCursor = (
  aceEditor,
  socket,
  curMgr,
  localUser,
  cursorFeat
) => {
  const { row, column } = aceEditor.current.editor.getCursorPosition();
  if (!cursorFeat) {
    try {
      curMgr.removeAll();
    } catch (error) {
      console.log('err');
    }
    return;
  }

  const cursor = aceEditor.current.editor.getCursorPosition();
  try {
    if (cursorFeat) {
      curMgr.setCursor(localUser.userId, cursor);
    } else {
      try {
        curMgr.removeAll();
      } catch (error) {}
    }
  } catch (error) {
    if (cursorFeat) {
      curMgr.addCursor(
        localUser.userId,
        localUser.name,
        localUser.color,
        cursor
      );
      curMgr.setCursor(localUser.userId, cursor);
    } else {
      try {
        curMgr.removeAll();
      } catch (error) {}
    }
  }

  socket.emit('cursor', { row, column });
};
